export default (event) => {
  const lowerCaseTrimmedInputValue = event.target.value.toLowerCase().trim();
  const eventCopy = { ...event, target: { ...event.target, value: lowerCaseTrimmedInputValue } };
  return eventCopy;
};
